import React, {useEffect} from "react";
import Container from 'react-bootstrap/Container';
import '../Lg.css';
import {TildaB} from "./common/TildaB";
import {logInfo, logPageOpened, logPixel} from "../../model/utils";
import {calculateLeadGenerationUrl, calcWhere} from "./common/LgHelper";
import {appdata} from "../../../logic_tmp/appdata/AppData";


export function ZerroFooter() {
    appdata.viewType = "FullPage"
    useEffect(() => {
        logPageOpened(appdata.parentPath,appdata.viewType)
        if (appdata["pixel"] !== undefined)
        {
            logPixel(appdata["pixel"])
        }
    }, []);
    return (
        <div>
            <Container>
                <TildaB>
                    <div className="center">DuoClassico 2024</div>
                </TildaB>
            </Container>
        </div>
    );
}

